import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

// import zhHant from 'vuetify/es5/locale/zh-Hant'
// import pl from 'vuetify/src/locale/pl'
// import sv from './i18n/vuetify/sv'

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        dark: false,
        themes:{
            light: {
                primary: "#B388FF",
                secondary: "#FFA726",
                tertiary: "#5BB25F",
                accent:"#A0A0A0",
                error:"#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",
                slider: "#FFEB3B",
                slider2: "#795548",
                even: "#F7F7F7",
                black: "#000000",
                white: "#FFFFFF",
                doing:colors.deepOrange,
                done:"#13B835",
                refuse:colors.grey,
                // toolbar:"EBB9C2",
                shsBtn:"#00A1B4",
            },
            dark: {
                primary: "#B388FF",
                secondary: "#FFA726",
                tertiary: "#5BB25F",
                accent:"#A0A0A0",
                error:"#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",
                slider: "#FFEB3B",
                slider2: "#795548",
                even: "#F7F7F7",
                black: "#000000",
                white: "#FFFFFF",
                doing:colors.deepOrange,
                done:"#13B835",
                refuse:colors.grey,
                // toolbar:"EBB9C2",
                shsBtn:"#00A1B4"
            },
        },
        options:{
            customProperties:true
        }
    },
});
